import React, { useState } from 'react';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { login } from '../services/authService';

interface LoginProps {
  onLoginSuccess: () => void;
}

export const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(username, password);
    setLoading(false);

    if (success) {
      onLoginSuccess();
    } else {
      setError('Usuário ou senha incorretos.');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="bg-bg-card p-8 rounded-lg shadow-xl border border-primary/10 w-full max-w-md animate-fade-in">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-serif text-primary mb-2">Psicanalista Gisela Serra</h2>
          <p className="text-primary/60 text-sm">Acesso Restrito ao Profissional</p>
        </div>

        <form onSubmit={handleSubmit}>
          <Input
            label="Usuário"
            type="text"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError('');
            }}
            placeholder="admin"
            required
            autoFocus
          />

          <Input
            label="Senha"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError('');
            }}
            placeholder="••••••••"
            required
          />

          {error && (
            <div className="mb-4 p-3 bg-red-50 text-red-700 text-sm rounded border border-red-100">
              {error}
            </div>
          )}

          <Button type="submit" className="w-full mt-2" variant="primary" disabled={loading}>
            {loading ? 'Verificando...' : 'Entrar no Painel'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <a href="#/" className="text-sm text-accent hover:underline">
            ← Voltar para o site
          </a>
        </div>
      </div>
    </div>
  );
};
